import { MoveIcon, TrashIcon } from '../../components/Icons'
import { useTexte } from '../../texte'

/*
 * The plural rule for the counter used to stand here (`nachrichtenWorte`);
 * since 1.86.4 it counts messages and separators apart and lives in
 * `texte/de.ts` as `chat.auswahlWorte`, read by the bar and the question.
 */

/**
 * Die Leiste am Fuss des Verlaufs, solange ausgewaehlt wird (#30).
 *
 * Aus dem Betrieb, nach dem Vorbild von WhatsApp und iMessage: „nach Auswahl
 * von Löschen im Menü: unten öffnet sich eine Leiste mit einem
 * Papierkorb-Symbol."
 *
 * **Sie ersetzt die Eingabezeile, statt sich darueberzulegen.** Zwei Leisten
 * uebereinander nehmen dem Verlauf auf 390 Punkten die halbe Hoehe -- und
 * schreiben kann man ohnehin nicht, waehrend man auswaehlt.
 *
 * **Ohne Netz ist der Papierkorb abgeschaltet, mit Grund.** Ein Loeschauftrag
 * geht nicht in den Ausgangskorb: er traefe Stunden spaeter auf einen
 * Verlauf, der inzwischen ein anderer ist. Also lieber gar nicht als
 * halb -- aber nie stillschweigend.
 */
export function Auswahlleiste({
  anzahl,
  trenner = 0,
  laeuft,
  online,
  onAbbrechen,
  onLoeschen,
  zweck = 'loeschen',
  onVerschieben,
}: {
  anzahl: number
  /** Picked separators (1.86.4), counted apart from the messages. */
  trenner?: number
  laeuft: boolean
  online: boolean
  onAbbrechen: () => void
  onLoeschen: () => void
  /**
   * What the selection is for (1.117.3): deleting or moving, chosen in the
   * menu. The bar carries one symbol, the one for that -- from use: "man
   * möchte Verschieben und wählt aus Versehen Löschen".
   */
  zweck?: 'loeschen' | 'verschieben'
  onVerschieben?: () => void
}) {
  const t = useTexte()
  const gesamt = anzahl + trenner
  const worte = t.chat.auswahlWorte(anzahl, trenner)
  const gesperrt = gesamt === 0 || laeuft || !online

  return (
    <div className="auswahlleiste" role="toolbar" aria-label={t.chat.auswahlLeiste} data-zweck={zweck}>
      <button type="button" className="button button--outline button--small" onClick={onAbbrechen}>
        {t.allgemein.abbrechen}
      </button>

      <span className="auswahlleiste__zahl" aria-live="polite">
        {gesamt === 0 ? t.chat.nichtsAusgewaehlt : t.chat.ausgewaehlt(worte)}
      </span>

      {zweck === 'verschieben' ? (
        <button
          type="button"
          className="icon-button"
          disabled={gesperrt}
          onClick={onVerschieben}
          aria-label={t.chat.verschieben.knopf}
          title={online ? undefined : t.allgemein.ohneNetz}
          data-schluessel="verschieben"
        >
          <MoveIcon size={20} />
        </button>
      ) : (
        <button
          type="button"
          className="icon-button icon-button--gefahr"
          disabled={gesperrt}
          onClick={onLoeschen}
          aria-label={t.chat.loeschenName(worte)}
          title={online ? undefined : t.allgemein.ohneNetz}
        >
          <TrashIcon size={20} />
        </button>
      )}

      {/* **Der Grund steht als Text da, nicht nur als `title`.** Auf dem
          Telefon ist ein Tooltip unsichtbar. */}
      {!online && <p className="auswahlleiste__hinweis">{t.allgemein.ohneNetz}</p>}
    </div>
  )
}
